import type { ReactNode } from 'react';
import { Link } from '@/lib/router';

export function Placeholder(props: { title: string; text: string; action?: { label: string; to: string } }): ReactNode {
    return (
        <main className="page page-scroll">
            <div className="placeholder">
                <h2>{props.title}</h2>
                <p>{props.text}</p>
                {props.action && (
                    <Link className="act" to={props.action.to}>
                        {props.action.label}
                    </Link>
                )}
            </div>
        </main>
    );
}
